import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import CalendarDropdown from "../../../component/smart/CalendarDropdown";
import momenttz from '../../../component/helpers/momenttz';
import './AvailableDatesNav.sass';

const AvailableDatesNav = (props) => {
	const { eventDate, availableDates, sizePerPage, getFleetEvents, getEquipmentRoutes, setPropStates, clearTimer, isTripHistory } = props
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'homePage.vehicleSidebar.availableDatesNav' });

	const isDayDisabled = (current) => {
		return !availableDates.includes(moment(current).format('YYYY-MM-DD'))
	}

	const onDateChanged = (current) => {
		if (!moment(current, 'MM/DD/YYYY', true).isValid()) {
			toastr.error('', i18n.t('toastMessage.toastrInfoValidDate'))
			return
		}

		setPropStates({ eventDate: current }, () => clearTimer());
		toastr.removeByType('error');
		if (getEquipmentRoutes) {
			const formattedDate = moment(current).format('YYYYMMDD');
			getEquipmentRoutes(formattedDate);
		} else {
			getFleetEvents(1, sizePerPage, true, current)
		}
	}

	const getPreviousEvents = () => {
		const pos = _.indexOf(availableDates, eventDate)
		if (pos === -1 && availableDates.length) {
			const arr = availableDates.filter((date) => {
				return (momenttz(date).format('YYYY-MM-DD') < momenttz(eventDate).format('YYYY-MM-DD'))
			})

			if (arr.length) {
				setPropStates({ eventDate: arr[arr.length - 1] }, () => clearTimer())
				getFleetEvents(1, sizePerPage, true, arr[arr.length - 1])
			} else {
				toastr.info('', t('toastrNoPreviousData', { value: isTripHistory ? 'trips' : 'events' }))
			}
		} else if (pos > 0) {
			setPropStates({ eventDate: availableDates[pos - 1] }, () => clearTimer())
			getFleetEvents(1, sizePerPage, true, availableDates[pos - 1])
		} else {
			toastr.info('', t('toastrNoPreviousData', { value: isTripHistory ? 'trips' : 'events' }))
		}
	}

	const getNextEvents = () => {
		const pos = _.indexOf(availableDates, eventDate)

		if (pos === -1 && availableDates.length) {
			const arr = availableDates.filter((date) => {
				return (momenttz(date).format('YYYY-MM-DD') > momenttz(eventDate).format('YYYY-MM-DD'))
			})

			if (arr.length) {
				setPropStates({ eventDate: arr[0] }, () => clearTimer())
				getFleetEvents(1, sizePerPage, true, arr[0])
			} else {
				toastr.info('', t('toastrNoFutureData', { value: isTripHistory ? 'trips' : 'events' }));
			}
		} else if (pos > -1 && pos < (availableDates.length - 1)) {
			setPropStates({ eventDate: availableDates[pos + 1] }, () => clearTimer())
			getFleetEvents(1, sizePerPage, true, availableDates[pos + 1])
		} else {
			toastr.info('', t('toastrNoFutureData', { value: isTripHistory ? 'trips' : 'events' }))
		}
	}

	return (
		<div className="AvailableDatesNav">
			<div className="arrows">
				<svg className="previous-date" onClick={getPreviousEvents} width='24px' height='24px' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path></svg>
			</div>
			<div className="input event-date">
				<CalendarDropdown
					date={moment(eventDate)}
					disabledDay={isDayDisabled}
					onChange={onDateChanged}
				/>
			</div>
			<div className="arrows">
				<svg className="next-date" onClick={getNextEvents} width='24px' height='24px' xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"></path></svg>
			</div>
		</div>
	)
}

AvailableDatesNav.propTypes = {
	eventDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(moment),
	]).isRequired,
	availableDates: PropTypes.arrayOf(PropTypes.string).isRequired,
	sizePerPage: PropTypes.number.isRequired,
	getFleetEvents: PropTypes.func.isRequired,
	setPropStates: PropTypes.func.isRequired,
	clearTimer: PropTypes.func.isRequired
}

export default AvailableDatesNav;
